module.exports = __webpack_public_path__ + "img/pxq.ac901fe7.png";